<template>
  <fieldset>
    <div :class="[getNameAttributeClassNames]">
      <InputValidator
        v-if="!showNameAttribute"
        :config="{
          attribute: 'name',
          label: inputLabel,
          name: nameAttributeName,
          placeholder: namePlaceholder,
          readonly: isReadOnly(nameReadOnly),
          type: 'text',
          validate: nameValidation,
          value: listItem.name,
        }"
        @InputValidatorModel="(index, listItem) => handleInputChange(index, listItem, 'name')"
      />
      <slot name="attributeInputLabel" />
    </div>
    <div :class="[getValueAttributeClassNames]">
      <component
        :is="valueDynamicComponent"
        v-bind="valueDynamicComponentProps"
        :config="{
          attribute: 'value',
          label: dropdownLabel,
          name: valueAttributeName,
          placeholder: showNameAttribute ? listItem.name : valuePlaceholder,
          readonly: isReadOnly(valueReadOnly),
          type: 'text',
          validate: valueValidation,
          value: listItem.value,
        }"
        @InputValidatorModel="(index, listItem) => handleInputChange(index, listItem, 'value')"
      />
    </div>
  </fieldset>
</template>
<script>
import BooleanAttributeInput from 'client/groups/User/BooleanAttributeInput.vue';
import CustomAttributeFieldsMixin from 'client/components/FormValidation/mixins/CustomAttributeFieldsMixin';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';
import TextareaValidator from 'client/components/FormValidation/TextareaValidator.vue';
import css from 'client/css/flex.css';

export default {
  name: 'CustomAttributeFields',

  inject: ['$validator'],

  components: {
    BooleanAttributeInput,
    InputValidator,
    TextareaValidator,
  },

  mixins: [CustomAttributeFieldsMixin],

  props: {
    dropdownLabel: {
      type: String,
      default: '',
    },
    inputLabel: {
      type: String,
      default: '',
    },
    showNameAttribute: {
      type: Boolean,
      default: false,
    },
    valueDynamicComponent: {
      type: [String, Object],
      default: 'InputValidator',
    },
    valueDynamicComponentProps: {
      type: Object,
      default: null,
    },
  },

  computed: {
    getNameAttributeClassNames() {
      const classNames = [this.$style.inputContainer, css.half];
      if (this.showNameAttribute) {
        classNames.push(this.$style.leftLabel);
      }
      return classNames;
    },
    getValueAttributeClassNames() {
      const classNames = [this.$style.inputContainer, css.half];
      if (this.showNameAttribute) {
        classNames.push(this.$style.rightLabel);
      }
      return classNames;
    },
  },

  methods: {
    handleInputChange(value, key, columnName) {
      this.handleChangeListItem({
        ...this.listItem, [key]: value,
      }, columnName);
    },
  },
};
</script>
<style module scoped>
.inputContainer {
  display: inline-block;
  vertical-align: top;
}

.leftLabel {
  float: left;
  width: calc(25% - 5px) !important;
}

.nameLabel {
  padding: 12px 0 0;
}

.rightLabel {
  float: right;
  width: calc(75% - 5px) !important;
}
</style>
